var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProgress3 = function SvgProgress3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551.209,
    height: 150,
    viewBox: "0 0 551.209 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_9019",
    x: 0,
    y: 0,
    width: 551.209,
    height: 150,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18607",
    "data-name": "Group 18607",
    transform: "translate(-516 -257.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17371",
    "data-name": "Group 17371",
    transform: "translate(16965 -21277.307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16449, 21535)",
    filter: "url(#Rectangle_9019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9019-2",
    "data-name": "Rectangle 9019",
    width: 533.209,
    height: 132,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#3cb9c0"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "The_second_step_is_to_set-up_a_security_pin_code_to_protect_your_data.",
    "data-name": "The second step is to set-up a security pin code to protect your data.",
    transform: "translate(792 356)",
    fill: "#f9f9f9",
    fontSize: 13,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -193.772,
    y: 0
  }, "The second step is to set-up a security pin code to protect your data.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_16015",
    "data-name": "Group 16015",
    transform: "translate(9.032 205)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1._Choose_Practice",
    "data-name": "1. Choose Practice",
    transform: "translate(544.968 100)",
    fill: "#f9f9f9",
    fontSize: 15,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1. Choose Practice")), /*#__PURE__*/React.createElement("text", {
    id: "_2._Security_Pin",
    "data-name": "2. Security Pin",
    transform: "translate(747.968 100)",
    fill: "#f9f9f9",
    fontSize: 15,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2. Security Pin")), /*#__PURE__*/React.createElement("text", {
    id: "_3._Photo_Privacy",
    "data-name": "3. Photo Privacy",
    transform: "translate(895.968 100)",
    fill: "#f9f9f9",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3. Photo Privacy")), /*#__PURE__*/React.createElement("path", {
    id: "Path_9814",
    "data-name": "Path 9814",
    d: "M0,0,6.014,6.175,12.025,0",
    transform: "translate(709.143 101.524) rotate(-90)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9815",
    "data-name": "Path 9815",
    d: "M0,0,6.014,6.175,12.025,0",
    transform: "translate(853.238 101.524) rotate(-90)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17542",
    "data-name": "Group 17542",
    transform: "translate(-9.039 -679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10735",
    "data-name": "Path 10735",
    transform: "translate(564.001 1001)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 466.5781555175781 5.5 L 5.874915599822998 5.5 C 4.383209705352783 5.5 2.988680124282837 5.207353115081787 1.948150753974915 4.676058769226074 C 1.027856588363647 4.206117630004883 0.5000330805778503 3.595176458358765 0.5000330805778503 3 C 0.5000330805778503 2.404823541641235 1.027856588363647 1.793882369995117 1.948150753974915 1.323941230773926 C 2.988680124282837 0.7926470637321472 4.383209705352783 0.5 5.874915599822998 0.5 L 466.5781555175781 0.5 C 468.0698547363281 0.5 469.4644470214844 0.7926470637321472 470.5050354003906 1.324000000953674 C 471.4253234863281 1.793941140174866 471.9531555175781 2.404823541641235 471.9531555175781 3 C 471.9531555175781 3.595176458358765 471.4253234863281 4.206058979034424 470.5050354003906 4.676000118255615 C 469.4644470214844 5.207353115081787 468.0698547363281 5.5 466.5781555175781 5.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.874908447265625 1 C 2.8990478515625 1 0.999969482421875 2.184529304504395 0.999969482421875 3 C 0.999969482421875 3.815470695495605 2.8990478515625 5 5.874908447265625 5 L 466.5781555175781 5 C 469.5540466308594 5 471.4530944824219 3.815470695495605 471.4530944824219 3 C 471.4530944824219 2.184529304504395 469.5540466308594 1 466.5781555175781 1 L 5.874908447265625 1 M 5.874908447265625 0 L 466.5781555175781 0 C 469.8228454589844 0 472.4530944824219 1.343117713928223 472.4530944824219 3 C 472.4530944824219 4.656882286071777 469.8228454589844 6 466.5781555175781 6 L 5.874908447265625 6 C 2.630279541015625 6 -3.0517578125e-05 4.656882286071777 -3.0517578125e-05 3 C -3.0517578125e-05 1.343117713928223 2.630279541015625 0 5.874908447265625 0 Z",
    stroke: "none",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17499",
    "data-name": "Group 17499",
    transform: "translate(563.072 996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10920",
    "data-name": "Path 10920",
    fill: "#f4456b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.330255508422852 15.5 C 4.012635707855225 15.5 0.4999954998493195 12.13551044464111 0.4999954998493195 8 C 0.4999954998493195 3.864490032196045 4.012635707855225 0.5 8.330255508422852 0.5 C 12.64787578582764 0.5 16.16051483154297 3.864490032196045 16.16051483154297 8 C 16.16051483154297 12.13551044464111 12.64787578582764 15.5 8.330255508422852 15.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.330255508422852 1 C 4.288335800170898 1 0.999995231628418 4.140190124511719 0.999995231628418 8 C 0.999995231628418 11.85980987548828 4.288335800170898 15 8.330255508422852 15 C 12.3721752166748 15 15.66051578521729 11.85980987548828 15.66051578521729 8 C 15.66051578521729 4.140190124511719 12.3721752166748 1 8.330255508422852 1 M 8.330255508422852 0 C 12.9309253692627 0 16.66051483154297 3.581720352172852 16.66051483154297 8 C 16.66051483154297 12.41827964782715 12.9309253692627 16 8.330255508422852 16 C 3.729585647583008 16 -3.814697265625e-06 12.41827964782715 -3.814697265625e-06 8 C -3.814697265625e-06 3.581720352172852 3.729585647583008 0 8.330255508422852 0 Z",
    stroke: "none",
    fill: "#f4456b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10737",
    "data-name": "Path 10737",
    transform: "translate(2.836 3)",
    fill: "#f4456b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.33025598526001 9 C 2.942545890808105 9 0.9999960064888 7.205609798431396 0.9999960064888 5 C 0.9999960064888 2.794389963150024 2.942545890808105 1 5.33025598526001 1 C 7.717966079711914 1 9.660515785217285 2.794389963150024 9.660515785217285 5 C 9.660515785217285 7.205609798431396 7.717966079711914 9 5.33025598526001 9 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.33025598526001 2 C 3.493946075439453 2 1.999996185302734 3.345789909362793 1.999996185302734 5 C 1.999996185302734 6.654210090637207 3.493946075439453 8 5.33025598526001 8 C 7.166565895080566 8 8.660515785217285 6.654210090637207 8.660515785217285 5 C 8.660515785217285 3.345789909362793 7.166565895080566 2 5.33025598526001 2 M 5.33025598526001 0 C 8.274076461791992 0 10.66051578521729 2.238580226898193 10.66051578521729 5 C 10.66051578521729 7.761420249938965 8.274076461791992 10 5.33025598526001 10 C 2.386435508728027 10 -3.814697265625e-06 7.761420249938965 -3.814697265625e-06 5 C -3.814697265625e-06 2.238580226898193 2.386435508728027 0 5.33025598526001 0 Z",
    stroke: "none",
    fill: "#f4456b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_10918",
    "data-name": "Path 10918",
    transform: "translate(1023 996)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.330255508422852 15.5 C 4.012635707855225 15.5 0.4999954998493195 12.13551044464111 0.4999954998493195 8 C 0.4999954998493195 3.864490032196045 4.012635707855225 0.5 8.330255508422852 0.5 C 12.64787578582764 0.5 16.16051483154297 3.864490032196045 16.16051483154297 8 C 16.16051483154297 12.13551044464111 12.64787578582764 15.5 8.330255508422852 15.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.330255508422852 1 C 4.288335800170898 1 0.999995231628418 4.140190124511719 0.999995231628418 8 C 0.999995231628418 11.85980987548828 4.288335800170898 15 8.330255508422852 15 C 12.3721752166748 15 15.66051578521729 11.85980987548828 15.66051578521729 8 C 15.66051578521729 4.140190124511719 12.3721752166748 1 8.330255508422852 1 M 8.330255508422852 0 C 12.9309253692627 0 16.66051483154297 3.581720352172852 16.66051483154297 8 C 16.66051483154297 12.41827964782715 12.9309253692627 16 8.330255508422852 16 C 3.729585647583008 16 -3.814697265625e-06 12.41827964782715 -3.814697265625e-06 8 C -3.814697265625e-06 3.581720352172852 3.729585647583008 0 8.330255508422852 0 Z",
    stroke: "none",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10735-2",
    "data-name": "Path 10735",
    d: "M2.923,0h229.19a2.962,2.962,0,0,1,2.923,3,2.962,2.962,0,0,1-2.923,3H2.923A2.962,2.962,0,0,1,0,3,2.962,2.962,0,0,1,2.923,0Z",
    transform: "translate(571.782 1001)",
    fill: "#f4456b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1030",
    "data-name": "Ellipse 1030",
    transform: "translate(799.714 996)",
    fill: "#fff",
    stroke: "#f4456b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33,
    cy: 8,
    rx: 8.33,
    ry: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33,
    cy: 8,
    rx: 7.83,
    ry: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10737-2",
    "data-name": "Path 10737",
    d: "M5.33,0a5.173,5.173,0,0,1,5.33,5,5.173,5.173,0,0,1-5.33,5A5.173,5.173,0,0,1,0,5,5.173,5.173,0,0,1,5.33,0Z",
    transform: "translate(802.688 999)",
    fill: "#f4456b"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgress3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/progress3.d53ade8c.svg";
export { ForwardRef as ReactComponent };